module.exports = __webpack_public_path__ + "media/images/talent/lp/case05-8c1a423f574fd91ad1bd6a5c0200ea9b.png";